import React from 'react';
import cn from 'classnames';
import type { IconProps } from '../icon-prop-types';
import { IconSizes } from '../icon-prop-types';
import * as Styles from '../Icon.module.scss';

export const MountainsIcon = ({ fill = 'black', size = 'xsmall' }: IconProps) => {
    const fillStyles = cn(Styles[fill], Styles.fill);
    const iconSize = IconSizes[size];
    return (
        <svg
            width={iconSize}
            height={iconSize}
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
            <path
                className={fillStyles}
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.7355 0.804077C11.2473 -0.212178 12.6707 -0.279206 13.2787 0.683418L21.184 13.2441H22.992C23.5443 13.2441 23.992 13.6918 23.992 14.2441C23.992 14.7963 23.5443 15.2441 22.992 15.2441H20.6489C20.6384 15.2442 20.6279 15.2442 20.6174 15.2441C17.0067 15.251 14.0225 17.9301 13.5367 21.4096H22.9924C23.5446 21.4096 23.9924 21.8573 23.9924 22.4096C23.9924 22.9618 23.5446 23.4096 22.9924 23.4096H12.4675H1.0203C0.936694 23.4113 0.852216 23.4026 0.768827 23.3827C0.651204 23.3548 0.541616 23.3062 0.444154 23.2408C0.321931 23.1593 0.222488 23.0541 0.148922 22.9345C0.012066 22.7121 -0.0352302 22.4401 0.0269854 22.1788C0.0466336 22.0956 0.0766657 22.0164 0.115637 21.9427L5.6081 11.0101L3.92922 8.3424L1.89377 12.396C1.66353 12.8542 1.12883 13.0586 0.658493 12.8869L0.551265 12.8406C0.0577681 12.5926 -0.141288 11.9916 0.106662 11.4981L2.5715 6.5923C3.08307 5.57643 4.50844 5.50656 5.11351 6.47037L6.657 8.92225L10.7355 0.804077ZM7.62603 11.4475C7.64176 11.4196 7.65611 11.391 7.66903 11.3619L12.0932 2.55481L18.9211 13.4034C14.9978 14.1442 11.9579 17.3864 11.5214 21.4096H2.62165L7.62603 11.4475Z"
            />
            <mask
                id="mask0_6029_9429"
                style={{ maskType: 'luminance' }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="24"
                height="24"
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.7355 0.804077C11.2473 -0.212178 12.6707 -0.279206 13.2787 0.683418L21.184 13.2441H22.992C23.5443 13.2441 23.992 13.6918 23.992 14.2441C23.992 14.7963 23.5443 15.2441 22.992 15.2441H20.6489C20.6384 15.2442 20.6279 15.2442 20.6174 15.2441C17.0067 15.251 14.0225 17.9301 13.5367 21.4096H22.9924C23.5446 21.4096 23.9924 21.8573 23.9924 22.4096C23.9924 22.9618 23.5446 23.4096 22.9924 23.4096H12.4675H1.0203C0.936694 23.4113 0.852216 23.4026 0.768827 23.3827C0.651204 23.3548 0.541616 23.3062 0.444154 23.2408C0.321931 23.1593 0.222488 23.0541 0.148922 22.9345C0.012066 22.7121 -0.0352302 22.4401 0.0269854 22.1788C0.0466336 22.0956 0.0766657 22.0164 0.115637 21.9427L5.6081 11.0101L3.92922 8.3424L1.89377 12.396C1.66353 12.8542 1.12883 13.0586 0.658493 12.8869L0.551265 12.8406C0.0577681 12.5926 -0.141288 11.9916 0.106662 11.4981L2.5715 6.5923C3.08307 5.57643 4.50844 5.50656 5.11351 6.47037L6.657 8.92225L10.7355 0.804077ZM7.62603 11.4475C7.64176 11.4196 7.65611 11.391 7.66903 11.3619L12.0932 2.55481L18.9211 13.4034C14.9978 14.1442 11.9579 17.3864 11.5214 21.4096H2.62165L7.62603 11.4475Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0_6029_9429)">
                <rect width="24" height="24" className={fillStyles} />
            </g>
        </svg>
    );
};
